import { Youtube, Music2, Instagram } from "lucide-react";

export default function Footer({ settings }) {
  const socials = [
    { url: settings?.youtube_url, icon: Youtube, label: "YouTube", testid: "social-youtube" },
    { url: settings?.tiktok_url, icon: Music2, label: "TikTok", testid: "social-tiktok" },
    { url: settings?.soundcloud_url, icon: Music2, label: "SoundCloud", testid: "social-soundcloud" },
    { url: settings?.instagram_url, icon: Instagram, label: "Instagram", testid: "social-instagram" },
  ].filter((s) => s.url);

  return (
    <footer data-testid="footer" className="relative bg-[#281620] text-[#f7efe2] pt-16 pb-10 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 text-center relative z-10">
        <p className="font-display text-3xl tracking-wide">
          Rosefield<span className="text-[#c2a04b]"> Harmonic</span>
        </p>
        <p className="font-accent text-sm text-[#e3b4b0] mt-3 tracking-wide max-w-md mx-auto">
          A living field of remembrance — sound, resonance, and sovereign awakening.
        </p>

        <div className="flex justify-center gap-4 mt-8">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={s.testid}
              aria-label={s.label}
              className="w-11 h-11 rounded-full border border-[#e3b4b0]/40 flex items-center justify-center text-[#e3b4b0] hover:bg-[#b76e79] hover:text-[#f7efe2] hover:border-[#b76e79] transition-all duration-300"
            >
              <s.icon size={19} />
            </a>
          ))}
        </div>

        <div className="hairline max-w-xs mx-auto my-9 opacity-50" />
        <p className="text-xs text-[#e3b4b0]/60 font-accent tracking-wide">
          © {new Date().getFullYear()} Rosefield Harmonic · Laura Lee Thayer
        </p>
      </div>
    </footer>
  );
}
